import { createUseStyles } from 'react-jss';
import { useTranslation } from 'react-i18next';
import { Theme } from '@app/theme';
import { toEuros } from 'lib/numbers';

const useStyles = createUseStyles((theme: Theme) => ({
  subPrice: {
    flex: 1,
    textAlign: 'right',
  },
  subTotalBlock: {
    backgroundColor: theme.colors.white,
    borderRadius: theme.borderRadius.std,
    padding: theme.marginBase * 2,
  },
  subTotalLine: {
    ...theme.fonts.h5,
    display: 'flex',
  },
  taxesLine: {
    marginTop: theme.marginBase / 2,
    ...theme.fonts.caption,
    display: 'flex',
  },
}));

interface Props {
  totalExclTaxes: number;
  taxes?: number;
}

export const SubTotal = ({ totalExclTaxes, taxes = 0 }: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.subTotalBlock}>
      <div className={classes.subTotalLine}>
        <div>{t('billing.studyPrice.subtotal.simpleTitle')}</div>
        <div className={classes.subPrice}>{toEuros(totalExclTaxes, true)}</div>
      </div>
      {taxes > 0 && (
        <div className={classes.taxesLine}>
          <div>{t('billing.studyPrice.taxes')}</div>
          <div className={classes.subPrice}>{toEuros(taxes, true)}</div>
        </div>
      )}
    </div>
  );
};
